import { CK_EDITOR_PORTAL_BODY_CLASS } from "@/shared/lib/isCKEditorElement";

/**
 * Ref-counted body flag shared by every CKEditor surface (CKEditorDialog and
 * ckEditorCompatible drawers). The class scopes the z-index / pointer-events
 * boost in ck-editor-overrides.css. A plain add/remove would let the first
 * surface to close strip the flag while another is still open, silently
 * breaking its portaled panels. The counter keeps the flag alive until the
 * last surface releases it.
 */
let activeCount = 0;

export const acquireCKEditorBodyFlag = () => {
  if (activeCount === 0) document.body.classList.add(CK_EDITOR_PORTAL_BODY_CLASS);
  activeCount += 1;

  return () => {
    activeCount -= 1;
    if (activeCount === 0) document.body.classList.remove(CK_EDITOR_PORTAL_BODY_CLASS);
  };
};
